export default function clampThresholds(values) {
  const { minValue, maxValue, warningEnabled, errorEnabled } = values;
  let { errorLower, errorUpper, warningLower, warningUpper } = values;

  if (minValue === undefined || maxValue === undefined) return values;

  if (errorLower === undefined) errorLower = minValue;
  if (errorUpper === undefined) errorUpper = maxValue;
  if (warningLower === undefined) warningLower = minValue;
  if (warningUpper === undefined) warningUpper = maxValue;

  if (!errorEnabled) {
    errorLower = minValue;
    errorUpper = maxValue;
  }

  if (!warningEnabled) {
    warningLower = errorLower;
    warningUpper = errorUpper;
  }

  errorLower = Math.max(minValue, Math.min(errorLower, maxValue));
  errorUpper = Math.max(minValue, Math.min(errorUpper, maxValue));
  errorLower = Math.min(errorLower, errorUpper);
  errorUpper = Math.max(errorLower, errorUpper);

  warningLower = Math.max(errorLower, Math.min(warningLower, errorUpper));
  warningUpper = Math.max(errorLower, Math.min(warningUpper, errorUpper));
  warningLower = Math.min(warningLower, warningUpper);
  warningUpper = Math.max(warningLower, warningUpper);

  return { minValue, maxValue, errorLower, errorUpper, warningLower, warningUpper, warningEnabled, errorEnabled };
}